module.exports = __webpack_public_path__ + "img/sidebanner.870c45f6.png";